// extracted by mini-css-extract-plugin
export default {"AccountInfoNavigate":"accountInfo_AccountInfoNavigate__Ug0Hl"};